import { Box, Card, CardContent, Typography } from "@mui/material";
import { Bar, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
  BarElement,
  Legend,
} from "chart.js";

import { Tooltip } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";

ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
  BarElement,
  Legend
);

interface ChartCardProps {
  title: string;
  data: any;
  type: string;
  isBelow800: boolean;
  info: any;
}

const ChartCard = ({ title, data, type, isBelow800, info }: ChartCardProps) => {
  return (
    <Card
      sx={{
        minWidth: 250,
        height: isBelow800 ? "100%" : 500,
        border: "1px solid #d2d2d3ff",
        borderRadius: 4,
        overflow: "hidden",
        position: "relative",
        pt: 0,
      }}
      elevation={0}
    >
      <CardContent>
        <Box display="flex" alignItems="center" sx={{ gap: "5px" }}>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            {title}
          </Typography>

          <Tooltip
            title={
              <>
                <Typography fontSize={16}>{info.desc}</Typography>
                <Typography fontSize={16}>{info.time}</Typography>
              </>
            }
          >
            <InfoOutlined
              color="action"
              fontSize="small"
              sx={{ mb: 1, cursor: "pointer" }}
            />
          </Tooltip>
        </Box>
        <Box
          mt={3}
          sx={
            isBelow800
              ? undefined
              : { height: "75%", width: "95%", position: "absolute" }
          }
        >
          {type === "Bar" ? (
            <Bar
              data={data}
              options={{
                responsive: true,
                maintainAspectRatio: isBelow800 ? true : false,
                plugins: {
                  legend: {
                    display: false,
                  },
                },
              }}
            />
          ) : (
            <Line
              data={data}
              options={{
                responsive: true,

                maintainAspectRatio: isBelow800 ? true : false,

                scales: {
                  y: {
                    ticks: {
                      stepSize: 40,
                    },
                  },
                },
                plugins: {
                  legend: {
                    display: false,
                  },
                },
                elements: {
                  line: {
                    tension: 0.4, // Smooth curve
                  },
                },
              }}
            />
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ChartCard;
